import styled from 'styled-components';

export const GeneralTabStyle = styled.div`
  position: relative;
  font-size: 16px;
  line-height: 20px;
  color: var(--light-gray);

  .title {
    display: block;
    font-size: 18px;
    line-height: 22px;
    margin: 0 0 10px;
    color: var(--text-color);
  }

  .email {
    display: block;
  }

  .holder {
    margin: 0 0 30px;

    &.flex-col {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }
  }
`;
